import SEO from '../../SEO';

export const LEGAL_LAST_UPDATED = 'October 28, 2026';

export const OPERATOR = {
  name: 'Johann Schneider',
  street: 'Fichtenstraße 5',
  city: '01097 Dresden',
  country: 'Germany',
  email: 'hello@kzcomp.com',
};

export const Section = ({ title, children }) => (
  <section className="flex flex-col gap-3">
    <h2 className="text-lg font-semibold tracking-tight">{title}</h2>
    <div className="flex flex-col gap-3 text-sm leading-relaxed text-foreground/80">{children}</div>
  </section>
);

export const Address = () => (
  <address className="not-italic">
    {OPERATOR.name}
    <br />
    {OPERATOR.street}
    <br />
    {OPERATOR.city}
    <br />
    {OPERATOR.country}
  </address>
);

export const ExternalLink = ({ href, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer noopener"
    className="text-primary underline-offset-4 hover:underline"
  >
    {children || href}
  </a>
);

export const MailLink = () => (
  <a href={`mailto:${OPERATOR.email}`} className="text-primary underline-offset-4 hover:underline">
    {OPERATOR.email}
  </a>
);

const LegalPage = ({ title, description, path, children }) => (
  <div className="mx-auto flex w-full max-w-3xl flex-col px-4 py-12 sm:px-6">
    <SEO title={title} description={description} canonicalPath={path} />
    <div className="mb-10 flex flex-col gap-2">
      <h1 className="font-display text-3xl font-semibold tracking-tight">{title}</h1>
      <p className="text-sm text-muted-foreground">Last updated: {LEGAL_LAST_UPDATED}</p>
    </div>
    <div className="flex flex-col gap-8">{children}</div>
  </div>
);

export default LegalPage;
